export interface ISelectedRegionsAndStates {
  regionsId: string[]
  statesId: string[]
  nationalSelected: boolean
}
